import cloneDeep from "lodash.clonedeep"
import { ctaBackgroundSettings } from "./cta-background-settings"

export const HTML = {
    type: "HTML",
    name: "HTML",
    children: [],
    general: {
        html: ""
    }
}

export const GENERAL = {
    type: "GENERAL",
    children: [],
    general: {
        landingBackground: "#F3F3F3",
        testBackground: false,
        modal: {
            isModal: false,
            padding: [10, 5, 10, 5],
            margin: [10, 10, 10, 10],
            background: "#FFFFFF",
            borderRadius: 10,
            shadow: {
                hasShadow: true,
                horizontal: 0,
                vertical: 4,
                blur: 10,
                color: "#809EBF47"
            },
            overlay: {
                isBlured: true,
                background: "#00000000"
            }
        }
    },
    desktop: {
        font: {
            family: "lato, sans-serif",
            size: 24
        }
    },
    mobile: {
        font: {
            family: "lato, sans-serif",
            size: 18
        }
    }
}

export const CUSTOM = {
    type: "CUSTOM",
    name: "Custom Block",
    children: [],
    general: {
        isRow: false,
        width: {
            value: 1000,
            type: "px"
        },
        height: {
            value: 100,
            type: "px"
        }
    },
    background: cloneDeep(ctaBackgroundSettings),
    desktop: {
        align: "center",
        justify: "center",
        padding: [0, 0, 0, 0],
        margin: [0, 0, 0, 0]
    },
    mobile: {
        align: "center",
        justify: "center",
        padding: [0, 0, 0, 0],
        margin: [0, 0, 0, 0]
    }
}

export const BUTTON = {
    type: "BUTTON",
    name: "Button",
    action: {
        type: "link",
        payload: {
            url: "https://kwiga.com",
            target: "_blank"
        }
    },
    general: {
        text: "JOIN COURSE",
        background: "#FF7439",
        hover: "#F26122",
        color: "#fff",
        style: "solid",
        stretched: false,
        border: {
            style: "none",
            width: 2,
            color: "transparent",
            radius: 4
        }
    },
    desktop: {
        width: {
            value: 300,
            type: "px"
        },
        height: {
            value: 50,
            type: "px"
        },
        padding: [0, 0, 0, 0],
        margin: [15, 0, 15, 0],
        font: {
            family: "lato, sans-serif",
            size: 24
        }
    },
    mobile: {
        width: {
            value: 400,
            type: "px"
        },
        height: {
            value: 50,
            type: "px"
        },
        padding: [0, 0, 0, 0],
        margin: [15, 0, 15, 0],
        font: {
            family: "lato, sans-serif",
            size: 18
        }
    }
}

const date = new Date()
export const TIMER = {
    type: "TIMER",
    name: "Timer",
    general: {
        type_id: 1,
        date: date.toISOString().split("T")[0],
        time: `${date.getHours()}:${date.getMinutes()}`,
        timezone: null,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        background: "transparent",
        color: "#151515",
        accent: "#3965FF",
        displayDays: true,
        displayLabels: true,
        displayHours: true,
        timerStyle: "round",
        font: {
            family: "Oswald, sans-serif",
            size: 26
        },
        width: {
            value: 80,
            type: "px"
        },
        height: {
            value: 80,
            type: "px"
        }
    },
    desktop: {
        padding: [0, 40, 0, 40],
        margin: [15, 0, 15, 0]
    },
    mobile: {
        padding: [30, 0, 0, 30],
        margin: [15, 0, 15, 0]
    }
}

export const LINK = {
    type: "LINK",
    name: "Link",
    general: {
        text: "Example Link"
    },
    link: {
        url: "/example",
        name: "Custom",
        target: "_blank"
    },
    desktop: {
        padding: [0, 0, 0, 0],
        margin: [15, 0, 15, 0],
        font: {
            family: "lato, sans-serif",
            size: 24
        }
    },
    mobile: {
        padding: [0, 0, 0, 0],
        margin: [15, 0, 15, 0],
        font: {
            family: "lato, sans-serif",
            size: 18
        }
    }
}

export const IMAGE = {
    type: "IMAGE",
    name: "Image",
    general: {
        src: "",
        alt: "",
        stretched: false,
        width: {
            value: 100,
            type: "%"
        },
        height: {
            value: 100,
            type: "%"
        },
        radius: {
            value: 2,
            type: "px"
        }
    },
    link: {
        has: false,
        url: "/example",
        name: "Custom",
        target: "_blank"
    },
    overlay: {
        enable: false,
        overlayed: false,
        alwaysDisplayedMobile: false,
        background: "transparent",
        color: "transparent",
        text: ""
    },
    desktop: {
        padding: [0, 0, 0, 0],
        margin: [10, 0, 10, 0]
    },
    mobile: {
        padding: [0, 0, 0, 0],
        margin: [10, 0, 10, 0]
    }
}

export const TEXT = {
    type: "TEXT",
    name: "Text",
    general: {
        text: "Example Text"
    },
    desktop: {
        padding: [5, 5, 5, 5],
        margin: [10, 0, 0, 0]
    },
    mobile: {
        padding: [5, 5, 5, 5],
        margin: [10, 0, 0, 0]
    }
}

export const CTA = {
    ...cloneDeep(CUSTOM),
    type: "CUSTOM",
    advanced: "CTA",
    name: "CTA Block",
    background: {
        ...cloneDeep(ctaBackgroundSettings),
        color: "#ffffff"
    },
    desktop: {
        ...cloneDeep(CUSTOM).desktop,
        align: "center"
    },
    mobile: {
        ...cloneDeep(CUSTOM).mobile,
        align: "center"
    },
    children: [
        {
            ...cloneDeep(TEXT),
            general: {
                text: '<p style="text-align: center; text-align: center"><span style="font-size: 24px; line-height: 1.5">Какой-то новый текст для CTA!</span></p><p style="text-align: center; text-align: center"><span style="font-size: 14px; line-height: 1.5">Какой-то новый текст для CTA! И тут такая </span><a target="_blank" rel="noopener noreferrer nofollow" href="/example"><span style="color: #1B7DE6; line-height: 1.5"><u>ссылка!</u></span></a></p>'
            }
        },
        { ...cloneDeep(BUTTON) }
    ],
    general: {
        allowCollapse: false,
        handlerBackground: "#F3F3F3",
        handlerColor: "#151515",
        width: {
            value: 1000,
            type: "px"
        },
        height: {
            value: 150,
            type: "px"
        }
    }
}

const STEP = {
    type: "STEP",
    name: "Step",
    children: [],
    isActive: false
}

export const FIELD = {
    type: "FIELD",
    name: "Field",
    general: {
        payload: {
            name: "builder.contact_field_payload",
            id: 1
        },
        stretched: true,
        isDefault: true,
        type: null,
        isHidden: false,
        isRequired: false,
        name: "",
        value: "",
        placeholder: "",
        colors: {
            name: "#52565C",
            text: "#52565C",
            placeholder: "#B5C1D2",
            background: "#FFFFFF",
            border: "#E0E0EC",
            focus: "#186dc9"
        },
        label: {
            margin: [0, 0, 4, 15]
        },
        fonts: {
            name: {
                family: "lato, sans-serif",
                size: 14
            },
            text: {
                family: "lato, sans-serif",
                size: 14
            },
            placeholder: {
                family: "lato, sans-serif",
                size: 14
            }
        }
    },
    desktop: {
        width: {
            value: 400,
            type: "px"
        },
        height: {
            value: 45,
            type: "px"
        },
        padding: [13, 15, 13, 15],
        margin: [15, 0, 0, 0]
    },
    mobile: {
        width: {
            value: 400,
            type: "px"
        },
        height: {
            value: 45,
            type: "px"
        },
        padding: [13, 10, 13, 10],
        margin: [15, 0, 0, 0]
    }
}

export const RADIO_FORM_GROUP = {
    type: "RADIO_FORM_GROUP",
    name: "Payment Processing",
    group: "ELEMENT",
    promoCode: {
        ...FIELD
    },
    general: {
        color: {
            text: "#52565C",
            radio: "#186dc9"
        }
    },
    desktop: {
        align: "center",
        justify: "center",
        padding: [0, 0, 0, 0],
        margin: [15, 0, 5, 0],
        font: {
            family: "lato, sans-serif",
            size: 14
        }
    },
    mobile: {
        align: "center",
        justify: "center",
        padding: [0, 0, 0, 0],
        margin: [15, 0, 5, 0],
        font: {
            family: "lato, sans-serif",
            size: 12
        }
    }
}

export const FORM = {
    type: "FORM",
    name: "Form",
    children: [
        {
            ...cloneDeep(STEP),
            isActive: true
        },
        { ...cloneDeep(STEP) }
    ],
    general: {
        payload: {
            name: "builder.contact_payload",
            id: 1,
            redirect: false,
            url: ""
        },
        tags: [],
        fieldColor: {
            name: "#52565C",
            text: "#52565C",
            placeholder: "#B5C1D2",
            background: "#FFFFFF",
            border: "#E0E0EC",
            focus: "#186dc9"
        },
        width: {
            value: 450,
            type: "px"
        },
        height: {
            value: 245,
            type: "px"
        },
        shadow: {
            hasShadow: false,
            horizontal: 0,
            vertical: 4,
            blur: 10,
            color: "#809EBF47"
        },
        loader: "#3965ff",
        loaderVisible: false
    },
    background: cloneDeep(ctaBackgroundSettings),
    desktop: {
        align: "center",
        justify: "center",
        padding: [10, 10, 10, 10],
        margin: [0, 0, 0, 0]
    },
    mobile: {
        align: "center",
        justify: "center",
        padding: [10, 10, 10, 10],
        margin: [0, 0, 0, 0]
    }
}
